export default __webpack_public_path__ + "static/media/QA-green.65e957ae.svg";